import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPaymentPredictMonthlyRow, IRequestModel, ISuccessFullPredictMonthlyResponse, ISuccessFullPredictResponse } from '../models/models'

export class GetSuccessFullPredictMonthlyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/payment/GetSuccesPosPredictMonthly',
      requesterInfo,
    })
  }

  public async getSuccessFullPredict(req: IRequestModel): Promise<IPaymentPredictMonthlyRow[]> {
    return await this.postAsync<IPaymentPredictMonthlyRow[]>(req)
  }
}
